import './main.less';
import groupBy from 'lodash/groupBy';
import _find from 'lodash/find';
import moment from 'moment';
import GropedByCell from './GroupedByCell';
import Cell from './Cell';
import CommentCell from './CommentCell';
import TotalCell from './TotalCell';

import React from 'react';

const Table = (props) => {
	const { table, setActiveRow, activeRowNumber, submitComment, getCommentsList, dropComment } = props;
	const { toggleUncoverByAdmin, toggleUncoverByAffiliate, uncoveredAffiliates, uncoveredAdmins } = props;
	const { rows, cols } = table;
	const affiliateOnlyRows = rows.filter(it => it.affiliate_id && !it.offer_id);

	return (
		<div className="traffic-accounting-wrap">
			<div className="table-container--projector__body">
				<div className="traffic-accounting-table">
					<div className="table_coll table_coll_main">
						<div className="table_cell top-row">Manager</div>
						{rows.map((row, index) =>
							<GropedByCell
								key={index} data={row} row_number={index} isGroupedByCol={true}
								setActiveRow={setActiveRow} activeRowNumber={activeRowNumber}
								toggleUncoverByAdmin={toggleUncoverByAdmin}
								toggleUncoverByAffiliate={toggleUncoverByAffiliate}
								uncoveredAdmins={uncoveredAdmins}
								affiliateRowId={getRowNumber(affiliateOnlyRows, row.admin, row.affiliate_id)}
								uncoveredAffiliates={uncoveredAffiliates}
							/>
						)}
					</div>
					<div className="scrolled_wrapper">
						{cols.map((column, index_col) => (
							<div className="table_coll date_coll" key={index_col}>
								<div className="table_cell top-row display-flex-column">
									<div className="top-row-date"><span>{ column }</span></div>
									<div className="display-flex">
										<div>Total</div>
										<div className="approved-number">Appr</div>
										<div className="">
											<span className="old">Old</span>/<span className="new">New</span>
										</div>
									</div>
								</div>
								{
									rows.map((row, index) =>
										<Cell
											column={column}
											data={row}
											key={index}
											row_number={index}
											index={`${index_col}-${index}`}
											setActiveRow={setActiveRow}
											activeRowNumber={activeRowNumber}
											isPayoutChangeRow={getHasPayoutChangeInRow(row)}
											hasConversionsInRow={getHasConversionsInRow(props.firstConversionDates, row)}
										/>
									)
								}
							</div>
						))}
					</div>
					<div className="table_coll total_coll">
						<div className="table_cell top-row">
							<p
								className="top-row-date"
								title="Only affiliates who had no leads during 30 days before change"
							>
								Affs with payout change
							</p>
							<div className="display-flex">
								<span className="pointer-hover" title="Affiliates with approve count">*</span>
								<span
									className="approved-number margin-0-10 pointer-hover"
									title="Approved leads count"
								>
									*
								</span>
								<span className="new pointer-hover" title="Affiliates without approve count">
									*
								</span>
							</div>
						</div>
						{
							rows.map((row, index) => (
								<TotalCell
									key={index}
									data={row}
									rows={rows}
									row_number={index}
									activeRowNumber={activeRowNumber}
									dropComment={dropComment}
									submitComment={submitComment}
									setActiveRow={setActiveRow}
									getCommentsList={getCommentsList}
								/>
							))
						}
					</div>
					<div className="table_coll comments_coll">
						<div className="table_cell top-row">
							<p>Notes</p>
						</div>
						{
							rows.map((row, index) => (
								<CommentCell
									key={index}
									data={row}
									row_number={index}
									activeRowNumber={activeRowNumber}
									dropComment={dropComment}
									submitComment={submitComment}
									setActiveRow={setActiveRow}
									getCommentsList={getCommentsList}
								/>
							))
						}
					</div>
				</div>
			</div>
		</div>
	);
};

function getRowNumber(affiliateOnlyRows, admin, affiliate_id) {
	const groupedByAdmin = groupBy(affiliateOnlyRows, 'admin');
	return groupedByAdmin[admin]
		?	groupedByAdmin[admin].map(i => i.affiliate_id).indexOf(affiliate_id)
		: null;
}

function getHasPayoutChangeInRow(row) {
	return Object.keys(row)
		.filter(key => key.startsWith('payout_change'))
		.some(key => !!row[key]);
}

function getHasConversionsInRow(firstConversionDates = [], row) {
	const firstConversionDate = _find(firstConversionDates, {
		country_id: row.country_id, affiliate_id: row.affiliate_id, offer_id: row.offer_id
	});
	const payoutChangeDates = Object.keys(row)
		.filter(key => key.startsWith('payout_change') && row[key])
		.map(item => item.replace('payout_change_', ''));

	if (!firstConversionDate || !payoutChangeDates[0]) {
		return false;
	}

	return moment(firstConversionDate.date)
		.isBefore(moment(payoutChangeDates[0].date).add(3, 'days').format('YYYY-MM-DD'));
}

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/traffic-accounting/components/table-start/main.js